var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-wrap",class:[_vm.wrapClass ? _vm.wrapClass : '']},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlDesc)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }